import {
  Routes,
  Route,
  Navigate,
  useParams,
  useLocation,
} from "react-router-dom";
import DashboardLayout from "../components/dashboardLayout/DashboardLayout";
import Home from "../pages/home/Home";
import PublicationAnalytics from "../pages/publicationAnalytics/PublicationAnalytics";
import DatasetAnalytics from "../pages/datasetAnalytics/DatasetAnalytics";
import PublicationData from "../pages/publicationData/PublicationData";
import Reports from "../pages/reports/Reports";
import Lookup from "../pages/lookup/Lookup";
import Glossary from "../pages/glossary/Glossary";
import About from "../pages/about/About";
import LandingPage from "../pages/landingPage/LandingPage";
import ChorusFunders from "../components/ChorusFunders/ChorusFunders";
import RouteGuard from "./RouteGuard";
import NotFound from "../pages/notFound/NotFound";
import PageNotFound from "../pages/pageNotFound/PageNotFound";
import LegacyRedirector from "./LegacyRedirector";
import Preprints from "../components/Preprints/Preprints";
import RootRouteHandler from "./RootRouteHandler";

// import { useParams } from "react-router-dom";

const RoutesList = () => {
  const location = useLocation();
  return (
    <Routes>
      {/* <Route path="/" element={<Navigate to="/funders" />} /> */}
      <Route path="/" element={<RootRouteHandler />} />
      {/* Entity guard */}
      <Route path="/:entityType" element={<RouteGuard />}>
        <Route index element={<Home />} />

        <Route element={<DashboardLayout />}>
          <Route
            path="publication-analytics"
            element={<PublicationAnalytics />}
          />
          <Route path="dataset-analytics" element={<DatasetAnalytics />} />
          <Route path="publication-data" element={<PublicationData />} />
          <Route path="reports" element={<Reports />} />
          <Route path="lookup" element={<Lookup />} />
          <Route path="glossary" element={<Glossary />} />
          <Route path="about" element={<About />} />

          <Route path=":shortName" element={<LegacyRedirector />} />
        </Route>
      </Route>

      <Route path="/preprints" element={<Preprints />} />
      <Route path="/page-not-found" element={<PageNotFound />} />
      <Route path="/*" element={<PageNotFound />} />
      {/* <Route path="*" element={<LandingPage />} /> */}
      {/* <Route path="*" element={<Navigate to="/" />} /> */}
    </Routes>
  );
};

export default RoutesList;
